import { ButtonHTMLAttributes, ReactNode } from 'react'
import s from './ButtonPill.module.scss'

export type ButtonPillColour = 'appleBlue'

interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'title'> {
    /** Button label. */
    title: string
    /** Optional leading icon. */
    icon?: ReactNode
    /** Optional fill. `appleBlue` is iOS system blue (#007AFF). */
    colour?: ButtonPillColour
}

export const ButtonPill = ({ title, icon, colour, className, type = 'button', ...rest }: Props) => (
    <button
        {...rest}
        type={type}
        className={[s.button, colour === 'appleBlue' ? s.appleBlue : '', className].filter(Boolean).join(' ')}
    >
        {icon && <span className={s.icon}>{icon}</span>}
        {title}
    </button>
)

export default ButtonPill
